export default "__VITE_ASSET__DETYhMFJ__"